import { Box } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import useToast from '../../../hooks/useToast';
// import { MANAGEMENT_APP_TABLE_DATA } from './constants';
import DiscoverAppPanel from './DiscoverAppPanel';
import {
  getDiscoverAppUserPanelAsync,
  getDiscoveryUsersAsync,
} from './DiscoverAppStore/discoverAppSlice';
import { DISCOVERY_APP_USER_DASHBOARD_COLUMN } from './column';

function capitalizeFirstLetter(string) {
  if (string !== '') {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return '';
}

function DiscoveryAppDash() {
  const dispatch = useDispatch();
  const { ErrorToast } = useToast();
  const [sortByPanel, setSortByPanel] = useState('week');
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [sort, setSort] = useState(1);
  const [page, setPage] = useState(1);

  const { discoverUserTotal, discoverUserData } = useSelector(
    ({ dashboardDiscoverReducer }) => {
      return {
        discoverUserTotal: dashboardDiscoverReducer.discoverUsersData
          ? dashboardDiscoverReducer.discoverUsersData.totalUsers
          : null,

        discoverUserData: dashboardDiscoverReducer.discoverUsersData
          ? dashboardDiscoverReducer.discoverUsersData.userList
          : null,
      };
    }
  );

  useEffect(() => {
    // api call
    dispatch(getDiscoverAppUserPanelAsync({ sortBY: 'week' }));
    dispatch(getDiscoveryUsersAsync({ page: 1, limit: 8 }));
  }, []);

  const handleSortDiscoverInfo = (e) => {
    setSortByPanel(e.target.value);
    // API call
    dispatch(getDiscoverAppUserPanelAsync({ sortBY: e.target.value }));
  };

  const handleSearchUserName = () => {
    // API call
    dispatch(
      getDiscoveryUsersAsync({
        page: 1,
        limit: 8,
        name,
        city: capitalizeFirstLetter(city),
        sort,
      })
    )
      .unwrap()
      .then((res) => {
        if (res && res.status > 299) {
          ErrorToast(res.message);
        }
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  const handleSearchUserCity = () => {
    // API call
    dispatch(
      getDiscoveryUsersAsync({
        page: 1,
        limit: 8,
        name,
        city: capitalizeFirstLetter(city),
        sort,
      })
    )
      .unwrap()
      .then((res) => {
        console.log('res', res);
        if (res && res.status > 299) {
          ErrorToast(res.message);
        }
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  const handleSortUserLatestOldest = (e) => {
    setSort(e.target.value);
    // API call
    dispatch(
      getDiscoveryUsersAsync({
        page: 1,
        limit: 8,
        name,
        city: capitalizeFirstLetter(city),
        sort: e.target.value,
      })
    )
      .unwrap()
      .then((res) => {
        if (res && res.status > 299) {
          ErrorToast(res.message);
        }
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getDiscoveryUsersAsync({
          page: val,
          limit: 8,
          name,
          city: capitalizeFirstLetter(city),
          sort,
        })
      )
        .unwrap()
        .then((res) => {
          if (res && res.status > 299) {
            ErrorToast(res.message);
          }
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
  };

  return (
    <Box pl={2}>
      <Box mb={2} fontSize={22} fontWeight={'fontWeightMedium'}>
        Discovery App User Panel
      </Box>
      <Box mb={2}>
        <BuzzSelect
          labelKey="label"
          valueKey="value"
          width={200}
          size={'small'}
          value={sortByPanel}
          onChange={handleSortDiscoverInfo}
          options={[
            { label: 'Last Week', value: 'week' },
            { label: 'Last Month', value: 'month' },
            { label: 'Last Year', value: 'year' },
          ]}
        />
      </Box>
      <Box mb={8}>
        <DiscoverAppPanel />
      </Box>
      <Box mb={2} fontSize={22} fontWeight={'fontWeightMedium'}>
        Discovery App User Info
      </Box>
      <Box mb={2} display={'flex'} maxWidth={700}>
        <BuzzInput
          placeholder={'Search by user name'}
          search
          flex={2}
          mr={2}
          value={name}
          onChange={(e) => setName(e.target.value)}
          size="small"
          onSubmitEditing={handleSearchUserName}
        />
        <BuzzInput
          placeholder={'Search by city name'}
          search
          flex={2}
          mr={2}
          value={city}
          onChange={(e) => setCity(e.target.value)}
          onSubmitEditing={handleSearchUserCity}
          size="small"
        />
        <BuzzSelect
          labelKey="label"
          valueKey="value"
          options={[
            { label: 'Sort by latest', value: 1 },
            { label: 'Sort by oldest', value: -1 },
          ]}
          placeholder="Assigned to"
          mr={2}
          value={sort}
          onChange={handleSortUserLatestOldest}
          size="small"
        />
      </Box>
      <Box>
        <BuzzTable
          columns={DISCOVERY_APP_USER_DASHBOARD_COLUMN}
          data={discoverUserData}
        />
        <Box display="flex" justifyContent="center">
          <BuzzPagination
            onClick={handlePageChange}
            total={discoverUserTotal}
            pageNo={page}
            defaultPage={1}
            perPage={8}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default DiscoveryAppDash;
